import React from "react";
import ReactDOM from "react-dom";
import App from "../src/components/App.js";

ReactDOM.render(<App />, document.getElementById("app"));